/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import { ProductCompareCarouselStyles } from "@monsma/Overrides/Widgets/ProductCompare/ProductCompareCarousel";
import ChevronLeft from "@monsma/XDL/Icons/ChevronLeft";
import Trash from "@monsma/XDL/Icons/Trash";
import { css } from "styled-components";

ProductCompareCarouselStyles.navigationLink = {
    icon: {
        iconProps: {
            src: ChevronLeft,
            color: "common.ui5",
            size: 13,
            css: css`
                margin-right: 5px;
            `,
        },
    },
};

ProductCompareCarouselStyles.headerTextGridItem = {
    width: 12,
};

ProductCompareCarouselStyles.headerText = {
    variant: "h2",
    forwardAs: "h1",
    css: css`
        margin-bottom: 0;
    `,
};

ProductCompareCarouselStyles.headerCountGridItem = {
    width: 6,
};

ProductCompareCarouselStyles.headerCount = {
    variant: "h5",
    css: css`
        margin-bottom: 20px;
    `,
};

ProductCompareCarouselStyles.headerButtonsGridItem = {
    width: 6,
    css: css`
        justify-content: flex-end;
        align-items: center;
        padding-bottom: 25px;
    `,
};

ProductCompareCarouselStyles.removeLink = {
    icon: {
        iconProps: {
            src: Trash,
            color: "common.ui16",
            size: 13,
            css: css`
                margin-right: 5px;
            `,
        },
    },
    hoverStyle: {
        color: "#FFA9A9",
    },
    color: "danger",
    css: css``,
};

ProductCompareCarouselStyles.headerGridItem = {
    width: 12,
};

ProductCompareCarouselStyles.headerContainer = {
    gap: 10,
    css: css`
        border-bottom: 1px solid ${getColor("common.ui12")};
    `,
};
